import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Container, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams, useNavigate } from "react-router-dom";

import Language from "../../Language";
import { useAuth } from '../../../contexts/AuthContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

import "./style.css";

export default function Header(props) {
  const { t } = useTranslation();
  const { user, userIsUnauthenticated } = useAuth();
  const navigate = useNavigate();
  const { lang } = useParams();

  return (
    <>
      <div className={`header ${props.className || ''}`}>
        <div className="container">
        {props.renderBg && <div className="bg_full"></div>}
        <Navbar collapseOnSelect expand="md" variant="dark" className="py-2 px-2">
          <Container>
            <Navbar.Brand>
              <Link to={`/${lang}/`} className="text-decoration-none link-info">
                <img
                  className="_logo"
                  src="/assets/images/head_logo.png"
                  alt="header-logo"
                />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse
              id="responsive-navbar-nav"
              className="justify-content-end"
            >
              <Nav>
                <Nav.Link onClick={() => user ? navigate(`/${lang}/account`) : navigate(`/${lang}/login`)}>
                  <FontAwesomeIcon icon={faUser} /> {t("account")}
                </Nav.Link>
                <Language key="3" />
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        </div>
      </div>
    </>
  );
}
